export type BetSlipMode = 'combi' | 'system';

export type BetSlipTicketType = 'single' | 'combi' | 'system' | 'multiway' | 'multiway-system';

export type BetSlipSubmissionKind = 'idle' | 'submitting' | 'accepted' | 'declined' | 'error';

export interface BetSlipSubmissionState {
  readonly kind: BetSlipSubmissionKind;
  readonly messageKey: string | null;
  readonly messageParams?: Record<string, string | number>;
}

export interface BetSlipSummaryOptions {
  readonly mode: BetSlipMode;
  readonly systemX: number;
  readonly stake: number;
  readonly balance: number | null;
  readonly minStake?: number;
  readonly maxStake?: number;
  readonly taxRate?: number;
  readonly maxOdds?: number;
  readonly maxProfit?: number;
  readonly minCombinationOdds?: number;
  readonly combiBonus?: readonly BetSlipCombiBonusTier[];
}

export interface BetSlipCombiBonusTier {
  readonly combi: number;
  readonly bonus: number;
}

export interface BetSlipBonusHint {
  readonly missingMatches: number;
  readonly minOdds: number;
  readonly bonusPercent: number;
}

export interface BetSlipSummaryViewModel {
  readonly mode: BetSlipMode;
  readonly effectiveMode: BetSlipMode;
  readonly ticketType: BetSlipTicketType;
  readonly ticketTypeKey: string;
  readonly selectionCount: number;
  readonly matchCount: number;
  readonly wayCount: number;
  readonly systemX: number;
  readonly systemY: number;
  readonly systemRows: number;
  readonly canUseSystem: boolean;
  readonly canDecreaseSystemX: boolean;
  readonly canIncreaseSystemX: boolean;
  readonly stake: number;
  readonly minStake: number;
  readonly maxStake: number;
  readonly maxAllowedStake: number;
  readonly stakeTooLow: boolean;
  readonly stakeTooHigh: boolean;
  readonly taxRate: number;
  readonly tax: number;
  readonly netStake: number;
  readonly totalOdds: number;
  readonly bonusPercent: number;
  readonly maxWin: number;
  readonly minCombination: number;
  readonly minCombinationOdds: number;
  readonly qualifiedMatchCount: number;
  readonly minCombinationReached: boolean;
  readonly invalidSelectionCount: number;
  readonly hasOutrightConflict: boolean;
  readonly hasH2HConflict: boolean;
  readonly requiresLogin: boolean;
  readonly hasSufficientFunds: boolean;
  readonly canSubmit: boolean;
  readonly primaryActionEnabled: boolean;
  readonly primaryActionKey: string;
  readonly blockingMessageKey: string | null;
  readonly blockingMessageParams?: Record<string, string | number>;
}

export interface BetSlipTicketPayload {
  readonly Bets: readonly BetSlipTicketBetPayload[];
  readonly SystemX: number;
  readonly SystemY: number;
  readonly Stake: number;
  readonly Tax: number;
  readonly MaxOdd: number;
  readonly MaxProfit: number;
  readonly Type: number;
  readonly WayCount: number;
  readonly SystemRows: number;
  readonly Bonus: number;
  readonly LB2SO: number;
  readonly TicketOrigin: number;
}

export interface BetSlipTicketBetPayload {
  readonly LB_OddID: number;
  readonly LB_BetTypeID: number;
  readonly LB_MatchID: number;
  readonly Bank: boolean;
  readonly BetTypeKey: number;
  readonly MatchStartDate: string;
  readonly SpecialOddValue: string;
  readonly MatchIdentifier: string;
  readonly IsLive: boolean;
  readonly MatchNumber: number;
  readonly Sport: number;
  readonly Active: boolean;
  readonly OddTypeKey: number;
  readonly OddFieldType: string;
  readonly Odd: number;
  readonly Competitors: string;
}

export interface BetSlipPlacementResponse {
  readonly Success: boolean;
  readonly ReservationCode?: string;
}

export const BET_SLIP_IDLE_SUBMISSION_STATE: BetSlipSubmissionState = {
  kind: 'idle',
  messageKey: null
};
